import React from 'react';
import { Stack, TextField } from '@mui/material';
import { isCustomerFieldRequired, type CustomerFieldErrorMap } from '../../customerCompleteness';
import type { CustomerFormDraft } from '../../customerFormDraft';

type Props = {
  draft: CustomerFormDraft;
  onChange: (patch: Partial<CustomerFormDraft>) => void;
  readOnly?: boolean;
  fieldErrors?: CustomerFieldErrorMap;
  requiredKeys?: ReadonlySet<keyof CustomerFormDraft>;
};

/** Kantor, kontak kerja, nama kontak lain. */
export function CustomerFormOfficeWorkTabScreen({
  draft,
  onChange,
  readOnly = false,
  fieldErrors,
  requiredKeys,
}: Props) {
  const req = (key: keyof CustomerFormDraft) =>
    isCustomerFieldRequired(key, { readOnly, requiredKeys });
  return (
    <Stack spacing={2} sx={{ maxWidth: 560 }}>
      <TextField
        label="Telp kantor"
        value={draft.office_phone}
        onChange={(e) => onChange({ office_phone: e.target.value })}
        required={req('office_phone')}
        error={Boolean(fieldErrors?.office_phone)}
        helperText={fieldErrors?.office_phone}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-office-phone' }}
      />
      <TextField
        label="Fax"
        value={draft.fax}
        onChange={(e) => onChange({ fax: e.target.value })}
        required={req('fax')}
        error={Boolean(fieldErrors?.fax)}
        helperText={fieldErrors?.fax}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-fax' }}
      />
      <TextField
        label="Nama kontak"
        value={draft.contact_name}
        onChange={(e) => onChange({ contact_name: e.target.value })}
        required={req('contact_name')}
        error={Boolean(fieldErrors?.contact_name)}
        helperText={fieldErrors?.contact_name}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-contact-name' }}
      />
      <TextField
        label="Jabatan"
        value={draft.job_title}
        onChange={(e) => onChange({ job_title: e.target.value })}
        required={req('job_title')}
        error={Boolean(fieldErrors?.job_title)}
        helperText={fieldErrors?.job_title}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-job-title' }}
      />
      <TextField
        label="Email kantor"
        value={draft.work_email}
        onChange={(e) => onChange({ work_email: e.target.value })}
        type="email"
        required={req('work_email')}
        error={Boolean(fieldErrors?.work_email)}
        helperText={fieldErrors?.work_email}
        fullWidth
        disabled={readOnly}
        inputProps={{ 'data-testid': 'customer-form-work-email' }}
      />
    </Stack>
  );
}
